import { Box, Flex, Text } from '@chakra-ui/react';
import { useMediaQuery } from '@chakra-ui/media-query';
import Layout from '../../components/Layout';
import Seo from '../../components/Seo';
import SuccessStory from '../../components/SuccessStory';
import { Key } from 'react';
import { useQuery } from '@apollo/client';
import { GET_CLIENTS } from '../../apollo/queries/GetClients';
import { GET_HEROES } from '../../apollo/queries/GetHeroes';
import BookConsultation from '../../components/SuccessStory/book-consultation';
import HeroesFlip from '../../components/SuccessStory/heroes';
import { GET_SSEXPERTS } from '../../apollo/queries/getSSExperts';
import Experts from '../../components/SuccessStory/experts';

const ClientSuccessStories = ({ global }) => {
  const [isLargerThan1024] = useMediaQuery('(min-width: 1024px)');
  let heroesData;
  let expertsData;
  let CLIENTS = [];

  // Load clients
  const clientsQueryRes = useQuery(GET_CLIENTS, {
    context: { clientName: 'strapi' },
    variables: {
      filters: {
        name: {
          eq: 'Clients',
        },
      },
    },
    fetchPolicy: 'cache-first',
  });

  const expertsQueryRes = useQuery(GET_SSEXPERTS, {
    context: { clientName: 'strapi' },
    variables: {
      filters: {
        name: {
          eq: 'Experts',
        },
      },
    },
    fetchPolicy: 'cache-first',
  });

  const heroesQueryRes = useQuery(GET_HEROES, {
    context: { clientName: 'strapi' },
    variables: {
      filters: {
        name: {
          eq: 'Heroes',
        },
      },
    },
    fetchPolicy: 'cache-first',
  });

  if (!expertsQueryRes.loading) {
    expertsData = expertsQueryRes.data.lists.data[0].attributes.entities.data;
  }

  if (!heroesQueryRes.loading) {
    heroesData = heroesQueryRes.data.lists.data[0].attributes.entities.data;
  }

  if (!clientsQueryRes.loading) {
    CLIENTS = clientsQueryRes.data.lists.data.map((item) => item);

    CLIENTS = CLIENTS[0].attributes.entities.data.filter(
      (item) => item.attributes.caseStudy.length > 0
    );
  }

  // Order customers based on their position
  CLIENTS = CLIENTS.sort(
    (
      a: { attributes: { position: number } },
      b: { attributes: { position: number } }
    ) => {
      return a.attributes.position - b.attributes.position;
    }
  );

  return (
    <Layout global={global}>
      <Seo seo={{}} />
      {!heroesQueryRes.loading &&
        !clientsQueryRes.loading &&
        !expertsQueryRes.loading && (
          <Box>
            <Box>
              <Box
                maxW={720}
                margin={isLargerThan1024 ? '4rem auto' : '4rem 2rem'}
              >
                <Text fontSize="1.1rem" lineHeight="1.7">
                  We&apos;re privileged to work with leading brands and partners
                  to make them content curation heroes. They&apos;re using
                  Anders Pink to curate content and get great recommendations
                  from the web, updated everyday.
                </Text>
              </Box>
              <Box maxW={550} margin={'4rem auto'} textAlign="center">
                <Text fontSize="1.6rem" fontWeight="700" color="#006067">
                  Here are just a few of our heroes, and what they have to say:
                </Text>
              </Box>
              <Box maxW={1150} margin={'4rem auto'}>
                <Flex flexWrap="wrap" justifyContent="space-around">
                  {CLIENTS.map((item: { attributes: { position: Key } }) => (
                    <SuccessStory key={item.attributes.position} item={item} />
                  ))}
                </Flex>
              </Box>
            </Box>
            <Flex
              flexDirection={'column'}
              justify={'center'}
              bgGradient="linear(to-l, #fafafa, #f2f2f2)"
              py={'4rem'}
            >
              <Box maxW={550} margin={'4rem auto'} textAlign="center">
                <Text fontSize="1.6rem" fontWeight="700" color="#006067">
                  See what some of our other heroes have to say...{' '}
                </Text>
              </Box>
              <HeroesFlip data={heroesData} />
            </Flex>
            <Flex
              flexDirection={'column'}
              justify={'center'}
              alignItems={'center'}
              maxW={720}
              margin={isLargerThan1024 ? '4rem auto' : '4rem 2rem'}
            >
              <Box margin={'4rem auto'} textAlign="center">
                <Text fontSize="1.6rem" fontWeight="700" color="#006067">
                  What industry experts are saying
                </Text>
              </Box>
              <Experts data={expertsData} />
            </Flex>
            <BookConsultation />
          </Box>
        )}
    </Layout>
  );
};

export default ClientSuccessStories;
